// F9 advisory for HR › Shifts. A Rider's shift and the store's receiving hours
// are separate facts (owner decision 2026-09-26); a delivery trip only fits where
// they overlap. HR is warned, never blocked: shifts may exist for other work, and
// HR validity does not depend on Delivery Setup.

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function minutes(value) {
  const match = /^(\d{1,2}):(\d{2})/.exec(String(value || ''));
  return match ? Number(match[1]) * 60 + Number(match[2]) : null;
}

export function clockLabel(value) {
  const total = minutes(value);
  if (total == null) return String(value || '');
  const hour = Math.floor(total / 60);
  const minute = String(total % 60).padStart(2, '0');
  return `${hour % 12 || 12}:${minute} ${hour < 12 ? 'AM' : 'PM'}`;
}

function listDays(days) {
  const names = days.map((day) => DAY_NAMES[day]);
  return names.length <= 1 ? names.join('') : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}

/**
 * Plain warnings for giving `shift` to a Rider, given the store's receiving
 * hours. Returns [] for non-Riders or when receiving hours are unknown.
 */
export function shiftDeliveryAdvice({ shift, receivingHours = [], isRider }) {
  if (!isRider || !shift || !receivingHours.length) return [];
  const window = receivingHours[0];
  const open = minutes(window.opensAt);
  const close = minutes(window.closesAt);
  const start = minutes(shift.start_time ?? shift.startTime);
  const endRaw = minutes(shift.end_time ?? shift.endTime);
  if ([open, close, start, endRaw].some((value) => value == null)) return [];
  const overnight = Boolean(shift.is_overnight ?? shift.isOvernight) || endRaw <= start;
  const end = overnight ? endRaw + 24 * 60 : endRaw;
  const hours = `${clockLabel(window.opensAt)}–${clockLabel(window.closesAt)}`;
  const advice = [];

  const overlap = Math.min(end, close) - Math.max(start, open);
  if (overlap <= 0) {
    advice.push(`This shift does not overlap the hours the store receives returning Riders (${hours}), so this Rider cannot be given delivery trips during it.`);
  } else {
    if (end > close) {
      advice.push(`This shift ends after the store stops receiving returning Riders (${clockLabel(window.closesAt)}). Delivery trips stop before the shift ends.`);
    }
    if (start < open) {
      advice.push(`This shift starts before the store opens for returning Riders (${clockLabel(window.opensAt)}). Delivery trips start from then.`);
    }
  }

  const closedDays = [0, 1, 2, 3, 4, 5, 6].filter((day) => !(window.daysOfWeek || []).includes(day));
  if (closedDays.length && overlap > 0) {
    advice.push(`The store does not receive returning Riders on ${listDays(closedDays)}, so this Rider gets no delivery trips on ${closedDays.length === 1 ? 'that day' : 'those days'}.`);
  }
  return advice;
}
